import React from "react";
import {VraagSolvabiliteitsAttestAanButton} from "./VraagSolvabiliteitsAttestAanButton";
import {HashLink} from 'react-router-hash-link';
import {NavItem} from "./NavItem.d";
import {GdwLogo} from "./GdwLogo";

const navItems: NavItem[] = [
  {label: 'Wat', link: "what"},
  {label: 'Hoe', link: "how"},
  {label: 'Wie', link: "who"},
  {label: 'Prijs', link: "price"},
  {label: 'Contact', link: "footer"}
];

export function Navbar() {
  return (
    <div className="fixed top-0 z-50 w-full text-gray-800 bg-white">
      <nav className="container flex z-20 justify-between items-center">
        <div className="my-5 mr-2 lg:my-6 flex items-center">
            <a href="/" className="mr-3">
              <img className="w-24 lg:w-36" src="/logo.png" alt="solvattest logo"/>
            </a>
            <GdwLogo black={true}/>
        </div>

        <div className="hidden lg:block text-sm text-neutral-grayish-blue">
          {navItems.map((navItem) => (
            <HashLink className="mx-3 py-5 hover:gradient-border-bottom hover:text-primary-green-apple font-medium"
                      to={`#${navItem.link}`}
                      key={navItem.link}
            >
              {navItem.label}
            </HashLink>
          ))}
        </div>

        <VraagSolvabiliteitsAttestAanButton/>
        <button className="hidden focus:outline-none">
          <img className="false" src="/icons/icon-hamburger.svg" alt=""/>
          <img className="hidden" src="/icons/icon-close.svg" alt=""/>
        </button>
      </nav>
    </div>
  )
}
